// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

import styles from './ProductItemBase.scss';

type Props = {
  children: React.Node,
  footer: React.Node,
  header: React.Node,
};

export default function ProductItemBase({
  children,
  footer,
  header,
}: Props): React.MixedElement {
  return (
    <>
      <Base tagName="li" flex flexCol className={styles.item}>
        {header}
        <Base flex gap="spacing-1x" flexCol className={styles.child}>
          {children}
        </Base>
        {footer}
      </Base>
      <hr />
    </>
  );
}
